import styled from "styled-components";

export const MoreDetailsArrowDefaultBox = styled.div`
  background-color: ${props => props.theme.components.gamingHistory.colors.background};
  align-self: stretch;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
`